import styled from 'styled-components';

interface RowProps {
  alignItems?: string;
  border?: string;
  borderBottom?: string;
  borderLeft?: string;
  borderRight?: string;
  borderTop?: string;
  bottom?: string;
  flex?: number | string;
  flexWrap?: string;
  gap?: string;
  height?: string;
  justifyContent?: string;
  left?: string;
  margin?: string;
  padding?: string;
  position?: string;
  right?: string;
  top?: string;
  width?: string;
}

const Row = styled.div<RowProps>`
  ${({ border }) => (border ? `border: ${border};` : null)}
  ${({ borderTop }) => (borderTop ? `border-top: ${borderTop};` : null)}
  ${({ borderBottom }) => (borderBottom ? `border-bottom: ${borderBottom};` : null)}
  ${({ borderLeft }) => (borderLeft ? `border-left: ${borderLeft};` : null)}
  ${({ borderRight }) => (borderRight ? `border-right: ${borderRight};` : null)}
  display: flex;
  flex: ${({ flex }) => flex || 1};
  ${({ flexWrap }) => (flexWrap ? `flex-wrap: ${flexWrap};` : null)}
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  ${({ margin }) => (margin ? `margin: ${margin};` : null)}
  ${({ gap }) => (gap ? `gap: ${gap};` : null)}
  ${({ padding }) => (padding ? `padding: ${padding};` : null)}
  ${({ position }) => (position ? `position: ${position};` : null)}
  ${({ height }) => (height ? `height: ${height};` : '')};
  ${({ bottom }) => (bottom ? `bottom: ${bottom};` : '')};
  ${({ top }) => (top ? `top: ${top};` : '')};
  ${({ left }) => (left ? `left: ${left};` : '')};
  ${({ right }) => (right ? `right: ${right};` : '')};
  width: ${({ width }) => width || '100%'};
`;

export { Row };
